import React, { useState } from 'react';
import { Box, Button, CircularProgress, Typography, LinearProgress } from '@mui/material';
import { storage } from '../../config/firebase';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';

interface ImageUploadFieldProps {
  label: string;
  value: string;
  onChange: (url: string) => void;
  storagePath: string; // e.g. 'logos'
  error?: boolean;
  helperText?: string;
}

const ImageUploadField: React.FC<ImageUploadFieldProps> = ({ label, value, onChange, storagePath, error, helperText }) => {
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files || e.target.files.length === 0) return;
    
    const file = e.target.files[0];
    const fileRef = ref(storage, `${storagePath}/${Date.now()}_${file.name}`);
    
    try {
      setUploading(true);
      setUploadProgress(0);
      
      // uploadBytesResumable kullanarak progress tracking
      const uploadTask = uploadBytesResumable(fileRef, file);
      
      uploadTask.on('state_changed',
        (snapshot) => {
          // Progress tracking
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setUploadProgress(progress);
          console.log(`Upload ${progress.toFixed(1)}% done for ${file.name}`);
        },
        (error) => {
          // Error handling
          console.error('Upload error:', error);
          alert('Dosya yüklenirken hata oluştu.');
          setUploading(false);
          setUploadProgress(0);
        },
        async () => {
          // Upload completed successfully
          try {
            const url = await getDownloadURL(uploadTask.snapshot.ref);
            onChange(url);
          } catch (error) {
            console.error('Error getting download URL:', error);
            alert('Dosya URL\'si alınırken hata oluştu.');
          } finally {
            setUploading(false);
            setUploadProgress(0);
          }
        }
      );
      
    } catch (err) {
      console.error('Dosya yüklenirken hata:', err);
      alert('Dosya yüklenirken hata oluştu.');
      setUploading(false);
      setUploadProgress(0);
    }
  };

  return (
    <Box sx={{ border: 1, borderColor: error ? 'error.main' : 'transparent', borderRadius: 1, p: error ? 1 : 0, mt: 2 }}>
      <Typography variant="subtitle1" sx={{ mb: 1, px: error ? 1 : 0 }}>{label}</Typography>
      {value && <img src={value} alt={label} style={{ maxWidth: '150px', display: 'block', marginBottom: 8, marginLeft: error ? '8px' : 0 }} />}
      <Box sx={{ px: error ? 1 : 0, pb: error ? 1 : 0 }}>
        <Button variant="outlined" component="label" disabled={uploading}>
          {uploading ? <CircularProgress size={20} /> : 'Fotoğraf Yükle'}
          <input type="file" accept="image/*" hidden onChange={handleFileChange} />
        </Button>
        {helperText && <Typography color="error" variant="caption" sx={{ display: 'block', mt: 1 }}>{helperText}</Typography>}
        {uploading && (
          <Box sx={{ mt: 2 }}>
            <LinearProgress 
              variant="determinate" 
              value={uploadProgress} 
              sx={{ borderRadius: 1, mb: 1 }}
            />
            <Typography variant="caption" sx={{ display: 'block', textAlign: 'center' }}>
              %{uploadProgress.toFixed(1)} tamamlandı
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ImageUploadField; 